//----------------------------------------------------Library
import React, { useEffect, useMemo, useState } from "react";
import { Button, CircularProgress, Grid, IconButton, InputAdornment, TextField, Typography } from "@material-ui/core";
import { Element, scroller } from 'react-scroll';
import { withStyles } from "@material-ui/core/styles";
import { Visibility, VisibilityOff } from "@material-ui/icons";
//----------------------------------------------------Redux
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as AccountActions from "../Actions/AccountActions";
import * as ProcessActions from "../Actions/ProcessActions";
//----------------------------------------------------Utils
import { asyncCheck } from "../Utils";
import { validateFields } from "../Utils/models";
//----------------------------------------------------Constants
import { SCROLL_OFFSET } from "../Constants";

const styles = (theme) => ({
  nextBtn: {
    margin: "20px 0 10px 0",
    height: "3rem",
    backgroundColor: '#155E98',
  },
  cartIcon: { color: "white" },
  cartHeader: {
    display: "grid",
    gridTemplateColumns: "1fr max-content",
    gridGap: "6px",
    marginTop: "10px",
  },
});

const TviTextFiled = withStyles({
  root: {
    "& .MuiInputLabel-root": { fontSize: "1.2em" },
    "& legend": { fontSize: "0.78em" },
  },
})(TextField);

const initailUser = {
  details: {
    address: {
      country: ''
    },
  },
  username: '',
  password: '',
  email: '',
};

const initailErrorForm = {
  firstName: { hasError: false },
  lastName: { hasError: false },
  email: { hasError: false },
  number: { hasError: false },
  country: { hasError: false },
  username: { hasError: false },
  password: { hasError: false },
  passwordConfirm: { hasError: false },
  street: { hasError: false },
  address: { hasError: false },
  suburb: { hasError: false },
  state: { hasError: false },
  postalCode: { hasError: false },
  day: { hasError: false },
  month: { hasError: false },
  year: { hasError: false },
  hasTraded: { hasError: false },
  tradedProducts: { hasError: false },
  tradeFrequency: { hasError: false },
  broker: { hasError: false },
  hearAboutUs: { hasError: false },
};

const fields = ["email", "username", "password", "passwordConfirm"];

const inputFieldDetails = {
  email: { autoComplete: 'email', label: 'Email' },
  username: { autoComplete: 'username', label: 'Username' },
  password: { autoComplete: 'new-password', label: 'Password' },
  passwordConfirm: { autoComplete: 'new-password', label: 'Confirm Password' },
};

const StepOne = (props) => {
  const [userAccount, setUserAccount] = useState(initailUser);
  const [formErrors, setFormErrors] = useState(initailErrorForm);
  const [goingNextStep, setGoingNextStep] = useState(false);
  const [showPass, setShowPass] = useState(false);

  useEffect(() => {
    if (goingNextStep === true) {
      let errorFields = Object.entries(formErrors).filter(([field, { hasError }]) => hasError && ["email", "username", "password", "passwordConfirm"].includes(field));
      if (errorFields.length === 0) {
        props.actions.nextStep();
        setTimeout(() => setGoingNextStep(false), 1000);
      } else {
        setGoingNextStep(false)
      }
    }
  }, [goingNextStep])

  const { classes, loading } = useMemo(() => {
    return { classes: props.classes, loading: props.loading }
  }, [props.classes, props.loading])

  const userDetails = userAccount.details;

  const scrollToElement = (elementName) => {
    scroller.scrollTo(elementName, {
      duration: 800,
      delay: 0,
      smooth: 'easeInOutQuart',
      offset: SCROLL_OFFSET
    });
  };

  const onChange = (field, value) => {
    // props.accountActions.updateUserAccount(field, value)
    setUserAccount({ ...userAccount, [field]: value });
  };

  const onAutoFill = (field, value) => {
    // if(prevValue === "" || !prevValue) props.accountActions.updateUserAccount(field, value);
    setUserAccount({ ...userAccount, [field]: value });
  };

  const onValidateField = (field) => {
    // const { userAccount } = props;
    const details = userAccount.details;

    const values = {};

    if (userAccount[field]) {
      values[field] = userAccount[field];
      if (field === 'passwordConfirm') values['password'] = userAccount['password'];
    } else if (details[field]) {
      values[field] = details[field];
    } else if (details.address[field]) {
      values[field] = details.address[field];
    }

    setFormErrors(validateFields([field], values, formErrors));
  };

  const goToNextStep = async () => {
    // props.accountActions.updateUserAccount(field, value)
    const { actions, accountActions, openSnackbar } = props;
    try {
      const details = userAccount.details || {};
      const { email, username } = userAccount;
      const values = fields.reduce((final, field) => {
        if (userAccount[field] !== undefined) final[field] = userAccount[field];
        else if (details[field] !== undefined) final[field] = details[field];
        else if (details.address[field] !== undefined) final[field] = details.address[field];

        return final;
      }, {});

      const newFormErrors = validateFields(fields, values, formErrors);
      const errorFields = Object.entries(newFormErrors).filter(([field, { hasError }]) => hasError && fields.includes(field));

      if (Object.keys(newFormErrors).filter(key => fields.includes(key)).some(key => newFormErrors[key] && newFormErrors[key].hasError)) {
        let elementName = `${errorFields[0][0]}`;
        scrollToElement(`element-${elementName}`);
        return setFormErrors(newFormErrors);
      }

      actions.setLoading(true);

      let result = await asyncCheck("email", email);
      if (!result.exist) {
        result = await asyncCheck('username', username);
      } else {
        openSnackbar({
          type: "warning",
          message: "Email already exists. Can not register.",
          open: true,
          duration: 4000
        });
        actions.setLoading(false);
        return;
      }

      if (result.exist === false) {
        // email does not exist
        accountActions.updateUserAccount(userAccount);
        setGoingNextStep(true);
        actions.setLoading(false);
      } else if (result.exist === true) {
        actions.setLoading(false);
        openSnackbar({
          type: "warning",
          message: "Username already exists. Can not register.",
          open: true,
          duration: 4000
        });
      } else throw new Error('Something went wrong. Please try again');

    } catch (error) {
      console.error(error);
      openSnackbar({
        type: "error",
        message: error.message,
        open: true,
      });
      actions.setLoading(false);
    }
  };

  const renderInputField = (field) => {
    if (field === 'country') {
      return;
    } else if (field === 'password' || field === 'passwordConfirm') {
      return (
        <Grid item xs={12} key={field}>
          <Element name={`element-${field}`}>
            <TviTextFiled
              autoComplete={inputFieldDetails[field].autoComplete}
              required
              onChange={(e) => onChange(field, e.target.value)}
              onInput={(e) => onAutoFill(field, e.target.value)}
              onBlur={() => onValidateField(field)}
              error={formErrors[field].hasError}
              label={`${inputFieldDetails[field].label}${formErrors.password.hasError ? " (Invalid)" : ""}`}
              type={showPass ? "text" : "password"}
              fullWidth
              id={field}
              name={field}
              variant="outlined"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => setShowPass(!showPass)}
                      edge="end"
                    >{showPass ? <Visibility /> : <VisibilityOff />}</IconButton>
                  </InputAdornment>
                ),
                autoComplete: 'new-password',
                form: { autocomplete: 'off' },
              }}
            />
          </Element>
        </Grid>
      )
    }

    return (
      <Grid item xs={12} key={field}>
        <Element name={`element-${field}`}>
          <TviTextFiled
            autoComplete={inputFieldDetails[field].autoComplete}
            required
            id={field}
            name={field}
            type={field === 'number' ? 'number' : 'string'}
            variant="outlined"
            fullWidth={true}
            defaultValue={userDetails[field] || ''}
            label={`${inputFieldDetails[field].label}${formErrors[field].hasError ? " (Invalid)" : ""}`}
            onChange={(e) => onChange(field, e.target.value)}
            onInput={(e) => onAutoFill(field, e.target.value)}
            onBlur={() => onValidateField(field)}
            error={formErrors[field].hasError}
            helperText={formErrors[field].hasError ? formErrors[field].errorMessage : ""}
          />
        </Element>
      </Grid>
    )
  }

  const renderForm = () => {
    return (
      <form noValidate>
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="stretch"
          spacing={2}
        >
          {fields.map(field => renderInputField(field))}

          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={goToNextStep}
              className={classes.nextBtn}
            >
              {loading ? <CircularProgress size={20} color='inherit' >&nbsp;Please Wait...</CircularProgress> : <Typography variant="h5">Next</Typography>}
            </Button>
          </Grid>
        </Grid>
      </form>
    )
  }


  return (
    <Grid container>
      <Grid item xs={12} style={{ paddingBottom: "6px", marginBottom: "5px" }}>
        <Typography variant="h4" gutterBottom><strong>Create New Account</strong></Typography>
      </Grid>
      <Grid item xs={12}>
        {renderForm()}
      </Grid>
    </Grid>
  );
}

StepOne.propTypes = {};

const mapStateToProps = ({ process, cartReducer, accountReducer }) => ({
  loading: process.loading,
  countries: process.countries,
  formErrors: process.formErrors,
  userAccount: accountReducer,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(ProcessActions, dispatch),
  accountActions: bindActionCreators(AccountActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(StepOne));